import { denormalize } from 'normalizr';

import * as schemas from 'schemas';

export const getNextBooking = state =>
  denormalize(state.bookings.nextBookingId, schemas.booking, state.entities);



// WEBPACK FOOTER //
// ./src/store/bookings/selectors.js